const getInputErros = (inputErro, name) => {
  return inputErro.indexOf(name) != -1 ? true : false;
};

export default getInputErros;
